<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <h2 class="text-lg mb-2 mt-5">รายงานการปฏิบัติงานรายเดือนของเจ้าหน้าที่ พม.</h2>
    <DataTreeTable
      :api-params="paramsComputed"
      :api-url="'member/getReportUserProgress/'"
      :method-request="'POST'"
      :data-array-table="dataArrayTable"
      :key="key"
      :table-name="'cm-report'"
      :default-sort="[{field:'cm_uid',dir:'desc'}]"
      :custom-sort="[{column: 'name', relateColumn: ['surname']}]"
      :downloadCsv="downloadCsv"
      @downloadCsvComplete="$emit('downloadCsvComplete')"
      reportName="รายงานการปฏิบัติงานรายเดือนของเจ้าหน้าที่ พม."
      :downloadExcel="downloadExcel"
      @downloadExcelComplete="$emit('downloadExcelComplete')"
    />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch, computed } from 'vue'
import DataTreeTable from "@/components/datatable/dataTreeDataTable.vue"
import dataReport from "../../example-data/json/report-4.json"

export default defineComponent({
  components:{
    DataTreeTable
  },
  props:{
    filter:{
        type: Object
    },
    downloadCsv:{
      type: Boolean
    },
    downloadExcel:{
      type: Boolean
    }
  },
  setup(props) {
    const params = ref({start: '1',draw: '1',length: '10'})
    const key = ref(1)
    watch(()=>props.filter, ()=>{
      key.value++
    })
    const paramsComputed = computed(() => ({...params.value, ...props.filter}))
    var customNameMutator = (value, data, type, params, component) => {
      return `${data.title ? data.title : ""}${data.name ? data.name: ""} ${data.surname ? data.surname : ""}`
    }
    const dataArrayTable = reactive([
      {title:"รหัส/เลขบัตรประจำตัวประชาชน", field:"cm_uid", minWidth: 230, width: 230, resizable:true},
      {title:"เจ้าหน้าที่รับผิดชอบ", field:"name", minWidth: 230, width: 230, variableHeight: true, mutator: customNameMutator},
      {title:"ระดับความเปราะบาง", field:"fragile_level", hozAlign:"center", minWidth: 120, width: 120, resizable:true},
      {title:"จำนวนครัวเรือนที่จัดเก็บสมุดพกเรียบร้อย", field:"household_cnt", hozAlign:"center", resizable:true, minWidth: 160, width: 160, 
        formatter:function(cell, formatterParams){
          return cell.getValue()
        }
      },
      {title:"จำนวนสมาชิก", field:"member_cnt", hozAlign:"center", resizable:true, minWidth: 100, width: 100,
        formatter:function(cell, formatterParams){
          return cell.getValue() ? cell.getValue() : null
        }
      },
      {title:"จำนวนสมาชิกที่มีภาวะพึ่งพิง", field:"member_problem_cnt", hozAlign:"center", resizable:true, minWidth: 120, width: 120, 
        formatter:function(cell, formatterParams){
          return cell.getValue()
        }
      },
      {title:"จำนวนครัวเรือนที่วางแผนพัฒนาคุณภาพชีวิตเรียบร้อย", field:"household_plan_cnt", hozAlign:"center", resizable:true, minWidth: 140, width: 140,
        formatter:function(cell, formatterParams){
          return cell.getValue()
        }
      },
      {title:"จำนวนครัวเรือนที่ดำเนินการให้ความช่วยเหลือ/พัฒนาคุณภาพชีวิตแล้ว", field:"household_help_cnt", hozAlign:"center", resizable:true, minWidth: 200, width: 200,
        formatter:function(cell, formatterParams){
          return cell.getValue()
        }
      },
      {//create column group
        title:"มิติสุขภาพ",
        columns:[
          {title:"มีปัญหา/ต้องพัฒนา", field:"prob_health.having_problem", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติสุขภาพที่มีปัญหา/ต้องพัฒนา",formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
          {title:"ดำเนินการแล้ว", field:"prob_health.processed", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติสุขภาพที่ดำเนินการแล้ว", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
        ],
      },
      {//create column group
        title:"มิติความเป็นอยู่",
        columns:[
          {title:"มีปัญหา/ต้องพัฒนา", field:"prob_family.having_problem", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติความเป็นอยู่ที่มีปัญหา/ต้องพัฒนา", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
          {title:"ดำเนินการแล้ว", field:"prob_family.processed", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติความเป็นอยู่ที่ดำเนินการแล้ว", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
        ],
      },
      {//create column group
        title:"มิติการศึกษา",
        columns:[
          {title:"มีปัญหา/ต้องพัฒนา", field:"prob_education.having_problem", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติการศึกษาที่มีปัญหา/ต้องพัฒนา", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
          {title:"ดำเนินการแล้ว", field:"prob_education.processed", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติการศึกษาที่ดำเนินการแล้ว", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
        ],
      },
      {//create column group
        title:"มิติรายได้",
        columns:[
          {title:"มีปัญหา/ต้องพัฒนา", field:"prob_occupation.having_problem", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติรายได้ที่มีปัญหา/ต้องพัฒนา", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
          {title:"ดำเนินการแล้ว", field:"prob_occupation.processed", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติรายได้ที่ดำเนินการแล้ว", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
        ],
      },
      {//create column group
        title:"มิติการเข้าถึงบริการภาครัฐ",
        columns:[
          {title:"มีปัญหา/ต้องพัฒนา", field:"prob_accessibility.having_problem", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติการเข้าถึงบริการภาครัฐที่มีปัญหา/ต้องพัฒนา", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
          {title:"ดำเนินการแล้ว", field:"prob_accessibility.processed", hozAlign:"right", width:120, minWidth: 120, hozAlign:"center", headerSort:false, titleDownload: "มิติการเข้าถึงบริการภาครัฐที่ดำเนินการแล้ว", formatter:
            function(cell, formatterParams){
              return cell.getValue()
            }
          },
        ],
      },
    ])
    const countCard = reactive([
      {
        text: "จำนวนครัวเรือน",
        approve_count: 28,
        reject_count: 28,
        icon: "house",
      },
      {
        text: "จำนวนครอบครัว",
        approve_count: 28,
        reject_count: 28,
        icon: "family",
      },
      {
        text: "จำนวนสมาชิก",
        approve_count: 28,
        reject_count: 28,
        icon: "member",
      },
      {
        text: "จำนวนความเปราะบาง",
        level_0: 28,
        level_1: 28,
        level_2: 28,
        level_3: 28,
        icon: "sensitive",
      },
    ]);

    return {
      dataArrayTable,
      dataReport,
      countCard,
      paramsComputed,
      key
    }
  }
})
</script>
<style lang="scss">
/*#tree-tabulator.tabulator{
  .tabulator-tree-level-0 [tabulator-field="household_count"],
  .tabulator-tree-level-0 [tabulator-field="family_count"],
  .tabulator-tree-level-0 [tabulator-field="member_count"],
  .tabulator-tree-level-0 [tabulator-field="sensitive_level_count"] {
    text-align: center !important;
    justify-content: center !important;
  }
}*/
.flex-1-5{
  flex: 1.5;
}
.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
    white-space: normal !important;
}
#tree-tabulator.tabulator .tabulator-header .tabulator-headers .tabulator-col{
  padding-top: 0!important;
}
</style>

